module.exports = {"Warn":"Warning","Error":"Error","Critical":"Critical","Ok":"Ok"}


//////////////////
// WEBPACK FOOTER
// ./src/_fdp/core/i18n/bundle/message-vi.json
// module id = bBkl
// module chunks = 1